<script lang="ts">
    import type { I18NMessage } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import type { Author } from "./TmemState";

    export let messageCode: I18NMessage;
    export let authors: Author[];
    export let action: string;
    export let id: string;
</script>

<div class="p-2 bg-gray-100  border-b">
    <p class="block text-xxs text-gray-500 uppercase">
        {getMessage(messageCode)}
    </p>
    <div
        class="flex flex-wrap justify-start items-center mb-1 text-sm text-gray-700"
        {id}
        data-action={action}
    >
        {#each authors as author}
            <button
                class="flex justify-center hover:text-red-500  items-center font-medium py-1 px-2 bg-white rounded-full text-gray-700 hover:bg-gray-100 border border-gray-300"
                data-id={author.id}
                data-name={author.name}
                data-action={action}
            >
                <span
                    class="text-xs font-normal leading-none max-w-full flex-initial"
                    >{author.name}</span
                >
                <span class="icon-close inline-block px-1" />
            </button>
        {/each}
    </div>
</div>
